import WORLD_COUNTRIES_FULL from './world-countries.json';
import WORLD_COUNTRIES from './world-countries-simplified.json';
import WORLD_CONTINENTS from './world-continents.json';
import CITIES from './cities.json';
import AFFILIATIONS from './affiliation.json';

const MIN_VALUE = 0;
const REDUCER_VALUE = 1000;
const START_WIDTH = 960;
const START_HEIGHT = 500;
const MIN_SCALE_VALUE = 1;
const MIN_DISTORSION = 10;
const MARGIN = 10;
const CONTINENTS_NAMES = [
	'Africa',
	'Asia',
	'Europe',
	'North America',
	'Oceania',
	'South America',
];
const FILTER_KEYWORDS = [
	'Based',
	'Nationality',
	'Origin',
	'Fellows',
	'Students',
	'Facilitators',
];
export {
	START_WIDTH,
	START_HEIGHT,
	WORLD_COUNTRIES,
	WORLD_CONTINENTS,
	MIN_DISTORSION,
	MIN_SCALE_VALUE,
	MIN_VALUE,
	REDUCER_VALUE,
	MARGIN,
	WORLD_COUNTRIES_FULL,
	CITIES,
	CONTINENTS_NAMES,
	AFFILIATIONS,
	FILTER_KEYWORDS,
};
